import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideoOn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"video-on, cam-on"} maskId="square-filled-radius-0-stroke-1-IconVideoOn"><path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H17V7.76148L22 5.76148V18.2385L17 16.2385V20H2ZM9.5 15C11.1569 15 12.5 13.6569 12.5 12C12.5 10.3431 11.1569 9 9.5 9C7.84315 9 6.5 10.3431 6.5 12C6.5 13.6569 7.84315 15 9.5 15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVideoOn;
